<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-8">For Sara Koenig, who underestimates her boundless wit and perspicacity</span><span class="char-style-override-4"></span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4"> </span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4"> </span></p>
<p class="Basic-Paragraph para-style-override-7"><span class="char-style-override-7">I would like to acknowledge the gracious assistance of the following law-enforcement officials, none of whom in any way appears in my book: Luther Hungate and his delightful wife Marsha, Ken Titsworth, J. B. Folsom, D. S. Hefner, Bud Dennis, Barry Gudgeon, Robert Gibson, and W. D. Colvard. Also, Louie Goforth, for his insights into human nature, and David McWethy, for his knowledge of the intricacies of the EPA and small-town rituals</span><span class="char-style-override-4">.</span><span class="char-style-override-4"></span></p>
<p class="Basic-Paragraph para-style-override-8"><span class="char-style-override-4"> </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Malice05.vue?6cda0ea8